import {OrganisationOnlinePaymentInvoicingMethodEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function organisationOnlinePaymentInvoicingMethodNameFilter(type: OrganisationOnlinePaymentInvoicingMethodEnum): string {
  switch (type) {
    case OrganisationOnlinePaymentInvoicingMethodEnum.ForceAlwaysIndividualInvoice: return i18n.t(LF.ForceAlwaysIndividualInvoice) as string;
    case OrganisationOnlinePaymentInvoicingMethodEnum.Selectable: return i18n.t(LF.UserChoice) as string;
  }
}
